export const BaseURL = "https://us-central1-proveit-muffins.cloudfunctions.net";
